import { Pipe, PipeTransform } from '@angular/core';
import {
  Assessment,
  BbsData,
  BbtData,
  CustomData,
  FgaData,
  NhptData,
  SingleNumberDataSet,
  SubTestDataSet,
  TugData,
} from '../services/model';

@Pipe({
  name: 'assessmentScoreTargetDiff',
  standalone: true,
})
export class AssessmentScoreTargetDiffPipe implements PipeTransform {
  damageLevels = [
    { icf: 4, min: 96, max: 100, color: '#ff0000a8' }, // Schädigung voll ausgeprägt
    { icf: 3, min: 50, max: 95, color: '#f5363975' }, // Schädigung erheblich ausgeprägt
    { icf: 2, min: 25, max: 49, color: 'orange' }, // Schädigung mäßig ausgeprägt
    { icf: 1, min: 5, max: 24, color: '#cdb832bd' }, // Schädigung leicht ausgeprägt
    { icf: 0, min: 0, max: 4, color: 'lightgray' }, // Schädigung nicht vorhanden
  ];

  transform(assessment: Assessment, side: 'left' | 'right' | 'none' = 'none', option: 1 | 2 = 1): string | number {
    if (assessment.type === 'ARAT') {
      let score = assessment.score;
      if (side === 'left') {
        score = assessment.score_left;
      }
      if (side === 'right') {
        score = assessment.score_right;
      }
      let diff = 0;
      if (score && score > -1) {
        diff = 57 - score;
        if (diff > 0) {
          return '(+ ' + diff + ' Pkt.)';
        }
      }
      return '';
    } else if (assessment.type === 'BBT') {
      const data = assessment.data as BbtData;

      let score = -1;
      let norm = 0;
      if (side === 'left') {
        norm = data.bbt.norm_left ?? 100;
        score = data.bbt.data[0].valueLeft ?? -1;
      }
      if (side === 'right') {
        norm = data.bbt.norm_right ?? 100;
        score = data.bbt.data[0].valueRight ?? -1;
      }
      let diff = 0;
      if (score && score > -1) {
        diff = norm - score;
        if (diff > 0) {
          return '(+ ' + diff + ' Bl.)';
        }
      }
      return '';
    } else if (assessment.type === 'BBS') {
      const data = assessment.data as BbsData;
      let score = 0;
      data.bbs.data.forEach(subSubTest => (score += subSubTest.value ?? 0));
      let diff = 0;
      diff = 56 - score;
      if (diff > 0) {
        return '(+ ' + diff + ' Pkt.)';
      }
      return '';
    } else if (assessment.type === 'FGA') {
      const data = assessment.data as FgaData;
      let score = 0;
      data.fga.data.forEach(subSubTest => (score += subSubTest.value ?? 0));
      let diff = 0;
      diff = 30 - score;
      if (diff > 0) {
        return '(+ ' + diff + ' Pkt.)';
      }
      return '';
    } else if (assessment.type === 'TUG') {
      const data = assessment.data as TugData;
      const subTest: SubTestDataSet<SingleNumberDataSet> = data.tug;
      let score = 0;
      score = subTest.data[0].value ?? -1;
      let diff = 0;
      if (score && score > -1) {
        diff = score - 9;
        if (diff > 0) {
          return '(- ' + diff + ' s)';
        }
      }
      return '';
      return score ?? -1 > -1 ? score + ' s' : -1;
    } else if (assessment.type === 'NHPT') {
      const data = assessment.data as NhptData;
      let value = -1;
      let norm = 0;
      if (side === 'left') {
        norm = data.nhpt.norm_left ?? 100;
        value = data.nhpt.data[0].valueLeft ?? -1;
      }
      if (side === 'right') {
        norm = data.nhpt.norm_right ?? 100;
        value = data.nhpt.data[0].valueRight ?? -1;
      }
      const zielwert = norm;

      if (value > zielwert) {
        const diff = zielwert - value;
        return '(' + Math.round(diff).toLocaleString('de-DE') + ' s)';
      } else {
        return '';
      }
    } else {
      return 0;
    }
    return 0;
  }

  hasValue(value: any): boolean {
    return value !== undefined && value !== null;
  }

  getScore(score: number | null | undefined): number {
    // umrechnung auf erfüllung statt Schädigung
    if (this.getPercent(score) < 0) {
      return -1;
    }
    return 100 - this.getPercent(score);

    // ehemals: icfScore zurückggeben...
    // return this.getIcf(this.getPercent(score));
  }

  getPercent(score: number | null | undefined): number {
    if (score !== undefined && score !== null && score > -1) {
      if (score <= 1 && score >= 0) {
        return Math.round(score * 100);
      } else {
        return -2;
      }
    } else {
      return -1;
    }
  }
  getIcf(score: number | null | undefined): number {
    if (score !== undefined && score !== null) {
      if (score === -2) {
        return -2;
      } else if (score === -1) {
        return -1;
      } else {
        for (const level of this.damageLevels) {
          if (score >= level.min && score <= level.max) {
            return level.icf;
          }
        }
      }

      return -1;
    } else {
      return -1;
    }
  }
}
